import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    paymentMethodRow: {
        alignItems: "center",
        minHeight: 114,
        padding: theme.spacing(1, 0),
        width: "100%",
        display: "flex",
        "&>.MuiGrid-item>svg": {
            display: "block",
            margin: "auto",
            color: theme.palette.primary.light,
            minWidth: 45,
            minHeight: 45,
        },
    },
    paymentCardImage: {
        width: 65,
        height: "auto",
        maxHeight: 40,
    },
    paymentCardImageContainer: {
        textAlign: "center",
    },
    payNowButton: {
        textAlign: "center",
        "& button": {
            marginTop: theme.spacing(4),
        },
    },
}));
